import DotLottie from '@zelos/shared/components/DotLottie';
import produce from 'immer';
import { useMemo } from 'react';
import type { CSSProperties } from 'react';

type LoadingProps = {
  size?: string,
  style?: CSSProperties,
  className?: string,
};

const Loading = ({ size, style = {}, className }: LoadingProps) => (
  <div
    className={className}
    style={useMemo(() => produce(style, (draft) => {
      size && Object.assign(draft, {
        width: size,
        height: size,
      });
    }), [size, style])}
  >
    <DotLottie
      autoPlay
      loop
      src="/lotties/loading_motion.lottie"
    />
  </div>
);

export default Loading;
